import { render, staticRenderFns } from "./ShippingCostHeadSearch.vue?vue&type=template&id=54e7d90c&scoped=true"
import script from "./ShippingCostHeadSearch.vue?vue&type=script&lang=js"
export * from "./ShippingCostHeadSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7d90c",
  null
  
)

export default component.exports